export default __webpack_public_path__ + "static/media/gold_reveal.25cbf442.mp3";